<script>
import BaseImportUpload from './BaseImportUpload.vue'
export default {
  components: {BaseImportUpload},
  props: {
    mediaType: String,
    itemId: Number|null,
    inputName: String|null,
  },
  emits: {
    back: null,
    addListItem: null,
    uploadError: null,
  },

  mounted() {
    console.log(this.mediaType)
  },
}
</script>

<template>
  <BaseImportUpload
      :media-type="this.mediaType"
      :item-id="this.itemId"
      :input-name="this.inputName"

      @back="this.$emit('back')"
      @uploadError="(error) => {this.$emit('uploadError', error) }"
  >

    <template v-slot:info-text>{{ $t('lists: upload members items info') }}</template>
    <template v-slot:info-title>{{ $t('lists: members list') }}</template>
    <template v-slot:upload-info>{{ $t('lists: upload members items') }}</template>
    <template v-slot:after-upload-block>
      <div class="my-3 para-blue">{{ $t('or') }}</div>
      <button type="button" class="btn btn-light mb-3 d-flex gap-2 align-items-center mx-auto" @click="this.$emit('addListItem')">
        {{ $t('polonr: add membership action') }} <i class="fa-solid fa-plus"></i>
      </button>
    </template>

  </BaseImportUpload>
</template>